import { IconButton } from '@mui/material'
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid'
import React, { useState } from 'react'
import Webcam from 'react-webcam'

const CamaraOn: React.FC<{ setImage: (image: any) => void; isMobile: boolean }> = ({ setImage, isMobile }) => {
  const [facingMode, setFacingMode] = useState<'user' | 'environment'>('user')
  const webcamRef = React.useRef<any>(null)

  const captureImage = () => {
    const screenshot = webcamRef.current.getScreenshot()
    if (screenshot) {
      const byteString = atob(screenshot.split(',')[1])
      const mimeString = screenshot.split(',')[0].split(':')[1].split(';')[0]

      const arrayBuffer = new ArrayBuffer(byteString.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }

      const blob = new Blob([arrayBuffer], { type: mimeString })
      const file = new File([blob], 'captured_image.jpg', { type: mimeString })
      setImage(file)
    }
  }
  return (
    <>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width="100%"
        videoConstraints={{ facingMode }}
      />
      <IconButton
        aria-label="capture"
        onClick={captureImage}
        sx={{
          position: 'absolute',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          borderRadius: '50%',
          width: 60,
          height: 60,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
          zIndex: 10
        }}
      >
        <div
          style={{
            borderRadius: '50%',
            border: '4px solid #ff0000',
            width: '80%',
            height: '80%'
          }}
        />
      </IconButton>
      {isMobile && (
        <IconButton
          onClick={() => setFacingMode(facingMode === 'user' ? 'environment' : 'user')}
          sx={{
            position: 'absolute',
            color: 'white',
            top: 10,
            right: 10,
            borderRadius: '50%',
            zIndex: 1000
          }}
        >
          <FlipCameraAndroidIcon />
        </IconButton>
      )}
    </>
  )
}

export default CamaraOn
